import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Indemnity = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Professional Indemnity</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">
          <div className="text-container">
            <p className="content-text">We have professional indemnity cover with AIG Insurance Company Limited.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
            <Footer />
    </div>
  );
};

export default Indemnity;